import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useCallback, useMemo, useState } from 'react';
const defaultGradientStops = 'transparent 135deg, var(--default-color) 180deg, transparent 225deg';
export const AnimatedGradientBorderWrapper = React.memo(function AnimatedGradientBorderWrapper({ children, borderRadius, borderGradientStops = defaultGradientStops, defaultColor = 'var(--accent-fg-primary)', }) {
    const [aspectRatio, setAspectRatio] = useState(1);
    const handleAspectRef = useCallback((node) => {
        if (node !== null) {
            setAspectRatio(node.clientWidth / node.clientHeight);
        }
    }, []);
    const animationWrapperStyles = useMemo(() => {
        return {
            ['--default-color']: defaultColor,
            ['--button-border-gradient-stops']: borderGradientStops,
            ['--button-aspect-ratio']: aspectRatio,
            ['--button-aspect-ratio-multiplier']: 0.65,
            transform: `translateY(-50%) scaleX(calc(var(--button-aspect-ratio) * var(--button-aspect-ratio-multiplier))`,
        };
    }, [aspectRatio, borderGradientStops, defaultColor]);
    const animationStyles = useMemo(() => {
        return {
            animation: 'spin 5s linear infinite',
        };
    }, []);
    return (_jsxs("div", { className: classNames('relative overflow-hidden p-px', 
        // Handle scaling when button wrapper
        '[&:has([data-content-wrapper]>button)]:active:scale-[0.97] duration-150 ease-outExpo'), ref: handleAspectRef, style: {
            borderRadius,
        }, children: [_jsx("div", { "data-content-wrapper": true, className: classNames('bg-base relative z-[1]', 
                // Adjust negative margin for button to account for internal padding
                '[&>button]:-my-px', 
                // Let the parent handle active scaling
                '[&>button]:active:scale-100'), style: {
                    borderRadius: borderRadius - 1,
                }, children: children }), _jsx("div", { style: animationWrapperStyles, className: "absolute inset-0 top-1/2 flex size-full items-center justify-center p-px will-change-transform", children: _jsx("div", { style: animationStyles, className: "absolute aspect-square min-h-full w-full origin-center bg-[conic-gradient(var(--button-border-gradient-stops))] blur-sm" }) })] }));
});
//# sourceMappingURL=AnimatedGradientBorderWrapper.js.map